module.exports = __webpack_public_path__ + "img/image15.0ca4ee81.webp";